/// <amd-module name="VSS/Features/MonacoWidgets/Registration" />
export { getLinkWidgetRegistration } from "./Widgets/LinkWidget";
